import type React from "react";
import { useState } from "react";
import { WizardLegendItem } from "@similarweb/ui-components";
import { i18nFilter } from "app/filters/i18nFilter";
import { EWizardLegendItemState } from "app/pages/digital-suite/home-page/components/ActivationWizard/Components/Step";
import {
    StepCloseWrapper,
    Title,
    BodyStep,
    IconStep,
    ButtonStyle,
    SkipText,
    IconIsAllSkipped,
} from "./StepCloseStyled";
import { colorsPalettes } from "@similarweb/styles";

interface IStepClose {
    onClick: (EnumSteps) => void;
    title: string;
    stepIndex: number;
    buttonText: string;
    isButtonShowAlways?: boolean;
    isSkip: boolean;
    isAllSkipped?: boolean;
}
export const StepClose: React.FC<IStepClose> = ({
    onClick,
    title,
    stepIndex,
    buttonText,
    isButtonShowAlways = false,
    isSkip,
    isAllSkipped = false,
}) => {
    const i18n = i18nFilter();
    const [isHover, setIsHover] = useState<boolean>(false);
    const toggleHover = (e, isHover: boolean) => {
        e.preventDefault();
        setIsHover(isHover);
    };
    return (
        <StepCloseWrapper
            onClick={onClick}
            style={{ cursor: "pointer" }}
            onMouseEnter={(e) => toggleHover(e, true)}
            onMouseLeave={(e) => toggleHover(e, false)}
        >
            <BodyStep>
                {!isAllSkipped ? (
                    <IconStep>
                        <WizardLegendItem
                            legendStepIndex={stepIndex}
                            label={""}
                            itemState={EWizardLegendItemState.COMPLETED}
                            showHoverIcon={false}
                            onClickFunc={null}
                            isStepCompleted={false}
                        />
                    </IconStep>
                ) : (
                    <IconIsAllSkipped
                        iconName={"clear"}
                        iconSize={"xs"}
                        iconColor={colorsPalettes.carbon[0]}
                    ></IconIsAllSkipped>
                )}
                <Title>{title}</Title>
                {isSkip ? <SkipText>{i18n("growth.homepage.activationWizard.skipInTheTitle")}</SkipText> : null}
            </BodyStep>
            {isHover || isButtonShowAlways ? (
                <ButtonStyle
                    isHoverStep={isHover}
                    type={"flat"}
                    height={"36px"}
                    onClick={onClick}
                >
                    {buttonText}
                </ButtonStyle>
            ) : null}
        </StepCloseWrapper>
    );
};
